interface SummaryResultsParams {
    summary?: string;
}

export const validateSummary = ({ summary }: SummaryResultsParams): { isError: boolean; response?: string } => {
    if (!summary) {
        return {
            isError: true,
            response: "Session summary is undefined",
        };
    }

    return {
        isError: false,
    };
};
